/* Cart slide-out for the redesigned site (replaces Monster Cart's).
   - "Add to cart" buttons ([data-add] inside [data-variant]) add without leaving the page and open the slide-out.
   - The slide-out reads Shopify's own cart (/cart.js), so prices, quantities and the volume savings applied
     by Shopify's automatic discounts are exactly what checkout will charge.
   - The cart icon's count updates after every change. */
(function () {
  var panel = document.getElementById('ii-cart');
  if (!panel) return;
  var list = panel.querySelector('.items'), foot = panel.querySelector('.foot'), empty = panel.querySelector('.empty');
  var badge = function () { return document.querySelector('.ii-header .cart'); };
  var locale = document.documentElement.lang || 'en';

  // Always two decimals in the cart ($26.00, not $26), so every line reads the same; currency code on the Canadian edition or when not USD.
  function money(cents, currency) {
    var s;
    try { s = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100); }
    catch (e) { s = '$' + (cents / 100).toFixed(2); }
    if (currency !== 'USD' || document.documentElement.getAttribute('data-edition') === 'ca') s += '<small class="cur">' + currency + '</small>';
    return '<span class="amt">' + s + '</span>';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function setCount(n) {
    var a = badge(); if (!a) return;
    var c = a.querySelector('.count');
    if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'count'; a.appendChild(c); } c.textContent = n; }
    else if (c) c.remove();
    a.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
  }

  function render(cart) {
    setCount(cart.item_count);
    var cur = cart.currency;
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    list.innerHTML = cart.items.map(function (it) {
      var saved = it.original_line_price > it.final_line_price;
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<li data-key="' + esc(it.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="80" height="56">' : '<span class="ph"></span>') +
        '<div class="info"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<span class="unit">' + money(it.final_price, cur) + (it.selling_plan_allocation ? ' a year' : ' each') +
        (saved ? ' <s>' + money(it.original_price, cur) + '</s>' : '') + '</span>' +
        (it.selling_plan_allocation ? '<span class="unit">Renews yearly</span></div>' :
        '<div class="qty"><button type="button" data-q="-1" aria-label="One fewer">&minus;</button>' +
        '<input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity">' +
        '<button type="button" data-q="1" aria-label="One more">+</button></div></div>') +
        '<div class="line">' + (saved ? '<s>' + money(it.original_line_price, cur) + '</s>' : '') +
        '<b>' + money(it.final_line_price, cur) + '</b>' +
        '<button type="button" class="rm" data-q="rm">Remove</button></div></li>';
    }).join('');
    // Each edition ships only to its own side of the border (U.S. edition: everywhere except Canada; Canadian edition: Canada only).
    // Shopify's checkout blocks a mismatch with a blunt error, so say it here first. Based on what's in the cart, not the
    // shopper's location: Shopify's idea of the shopper's country follows the edition switch, not the delivery address.
    var warn = panel.querySelector('.edwarn'), msg = '', both = false;
    var printed = cart.items.filter(function (it) { return !it.selling_plan_allocation && it.requires_shipping; });
    var hasCa = printed.some(function (it) { return /can/.test(it.handle); }), hasUs = printed.some(function (it) { return !/can/.test(it.handle); });
    if (hasCa && hasUs) { both = true;
      msg = 'Your cart has both editions, which can’t be shipped to the same address: the U.S. edition ships everywhere except Canada, and the Canadian edition ships within Canada only. Please remove one.'; }
    else if (hasUs) msg = 'The U.S. edition ships worldwide except to Canada. For delivery in Canada, order the <a href="/products/2026-can">Canadian edition</a>.';
    else if (hasCa) msg = 'The Canadian edition ships within Canada only. For delivery outside Canada, order the <a href="/products/2026">U.S. edition</a>.';
    warn.innerHTML = msg; warn.hidden = !msg; warn.classList.toggle('both', both);
    var savings = cart.original_total_price - cart.total_price;
    panel.querySelector('.save').hidden = savings <= 0;
    panel.querySelector('.save b').innerHTML = '−' + money(savings, cur);
    panel.querySelector('.sub b').innerHTML = money(cart.total_price, cur);
  }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(key, qty) {
    panel.classList.add('busy');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); })
      .then(render).finally(function () { panel.classList.remove('busy'); });
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    panel.hidden = false;
    setTimeout(function () { panel.classList.add('open'); }, 20);
    document.documentElement.style.overflow = 'hidden';
    panel.querySelector('.close').focus({ preventScroll: true });
  }
  function close() {
    panel.classList.remove('open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { panel.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });  // without preventScroll the browser scrolls the button into view (page jump)
  }
  window.iiCart = { open: function () { getCart().then(render).then(open); } };

  panel.addEventListener('click', function (e) {
    if (e.target === panel || e.target.closest('.close') || e.target.closest('.keep')) return close();
    var b = e.target.closest('[data-q]'); if (!b) return;
    var li = b.closest('li'), input = li.querySelector('input');
    var q = b.dataset.q === 'rm' ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.dataset.q));
    change(li.dataset.key, q);
  });
  panel.addEventListener('change', function (e) {
    if (e.target.matches('.qty input')) change(e.target.closest('li').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

  // The cart icon opens the slide-out instead of leaving the page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.ii-header .cart');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); window.iiCart.open();
  });

  // Add to cart without leaving the page. The buttons are plain buttons, not a Shopify product form:
  // app scripts on the store hijack product forms and send shoppers straight to checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    var box = btn.closest('[data-variant]'); if (!box) return;
    e.preventDefault();
    var qtyInput = box.querySelector('.qty input');
    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(box.dataset.variant), quantity: qty }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); })
      .then(getCart).then(function (cart) { panel.querySelector('.err').hidden = true; render(cart); open(); })
      .catch(function (err) { alertMsg(err.message); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });

  // /cart redirects here with ?cart=open (see sections/ii-cart-page.liquid): open the slide-out and tidy the address bar.
  if (/[?&]cart=open/.test(location.search)) {
    history.replaceState(null, '', location.pathname + location.search.replace(/[?&]cart=open/, '').replace(/^&/, '?') + location.hash);
    getCart().then(render).then(open);
  }

  // Keep the count on the cart icon right, including after the Back button (the browser may show a stored copy of the page).
  window.addEventListener('pageshow', function () { getCart().then(function (c) { setCount(c.item_count); }); });

  function alertMsg(m) {
    var el = panel.querySelector('.err'); el.textContent = m; el.hidden = false;
    getCart().then(render).then(open);
  }
})();
